import { Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate, CanActivateFn, Router } from '@angular/router';
import { LoginServicesService } from '../services/login-services.service';


@Injectable({
  providedIn: 'root'
})


export class Admin implements CanActivate {
  data:any;
  constructor(private authService: LoginServicesService, private router: Router,private activatedRoute: ActivatedRoute) {}

  canActivate(): boolean {
this.data =JSON.parse(localStorage.getItem('data')!); 
    

    if (this.data.UserType == 'Administrator' || this.data.UserType == 'Modify') {
      return true;
    } else {
      this.router.navigate(['app/dashboard']);
      return false;
    }
  }
}